import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LevelUp = _resolveComponent("LevelUp")!
  const _component_GenericSubPanel = _resolveComponent("GenericSubPanel")!
  const _component_SelectSkill = _resolveComponent("SelectSkill")!
  const _component_Drugs = _resolveComponent("Drugs")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "actions-container",
    title: "ACTIONS"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_GenericSubPanel, { height: "93px" }, {
          default: _withCtx(() => [
            _createVNode(_component_LevelUp)
          ]),
          _: 1
        }),
        _createVNode(_component_GenericSubPanel, null, {
          default: _withCtx(() => [
            _createVNode(_component_SelectSkill)
          ]),
          _: 1
        }),
        _createVNode(_component_GenericSubPanel, null, {
          default: _withCtx(() => [
            _createVNode(_component_Drugs)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}